// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusMarker_root__32xwl"};